import { Checkbox, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import SectionShell from './SectionShell'
import { GlobalRow } from './utils'
import { CheckboxWithPolicyBadge, policyMatchesGlobalRow } from './PolicyMatches'
import { PermissionPolicyDTO } from '../../domain/permission/PermissionPolicyDTO'

type GlobalSectionProps = {
  rows: readonly GlobalRow[]
  open: boolean
  onToggleOpen: () => void
  isChecked: (row: GlobalRow) => boolean
  onToggleRow: (row: GlobalRow) => void
  selectedPolicies: ReadonlyArray<PermissionPolicyDTO>
}

const GlobalSection = ({ rows, open, onToggleOpen, isChecked, onToggleRow, selectedPolicies }: GlobalSectionProps) => {
  const visibleRows = open ? rows : []
  const hiddenCount = rows.length
  const ncols = 2

  return (
    <SectionShell
      title="Global permissions"
      open={open}
      onToggleOpen={onToggleOpen}
      hasFooterToggle={hiddenCount > 0}
      footerLabel={`Show ${hiddenCount} more`}
      ncols={ncols}
      testId="matrix-section-global"
    >
      {open && (
        <TableHead>
          <TableRow sx={{ bgcolor: 'action.hover' }}>
            <TableCell sx={{ minWidth: 240, borderRight: 1, borderColor: 'divider' }}>
              <Typography variant="subtitle2">Action</Typography>
            </TableCell>
            <TableCell sx={{ minWidth: 80 }}>
              <Typography variant="subtitle2">Granted</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        {visibleRows.map((row) => {
          const matches = policyMatchesGlobalRow(selectedPolicies, row.action)
          return (
            <TableRow key={row.id} hover data-testid={`matrix-row-${row.id}`}>
              <TableCell sx={{ borderRight: 1, borderColor: 'divider', bgcolor: 'action.hover' }}>
                {row.label}
              </TableCell>
              <TableCell>
                <CheckboxWithPolicyBadge matches={matches}>
                  <Checkbox
                    size="small"
                    checked={isChecked(row)}
                    onChange={() => onToggleRow(row)}
                    inputProps={{ 'aria-label': `${row.label} permission` }}
                    data-testid={`matrix-global-checkbox-${row.id}`}
                    sx={{ p: 0.25 }}
                  />
                </CheckboxWithPolicyBadge>
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </SectionShell>
  )
}

export default GlobalSection
